module.exports = __webpack_public_path__ + "static/inner-ads-de2a2a7ad355f8200a169bbc1e2d735b.jpg";